import { render, staticRenderFns } from "./SupplyTerms.view.vue?vue&type=template&id=ae88fa96&"
import script from "./SupplyTerms.view.vue?vue&type=script&lang=js&"
export * from "./SupplyTerms.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev1/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae88fa96')) {
      api.createRecord('ae88fa96', component.options)
    } else {
      api.reload('ae88fa96', component.options)
    }
    module.hot.accept("./SupplyTerms.view.vue?vue&type=template&id=ae88fa96&", function () {
      api.rerender('ae88fa96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/rearchitected/themes/atmo/views/pages/purchases/item/view/partials/SupplyTerms.view.vue"
export default component.exports